import { render, staticRenderFns } from "./ObservationDialog.vue?vue&type=template&id=39b24708&scoped=true"
import script from "./ObservationDialog.vue?vue&type=script&lang=js"
export * from "./ObservationDialog.vue?vue&type=script&lang=js"
import style0 from "./ObservationDialog.vue?vue&type=style&index=0&id=39b24708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b24708",
  null
  
)

export default component.exports